import { COPY_VARIATIONS, STORAGE_KEYS } from './self-like-easter-egg.constants';
import type { Variant } from './self-like-easter-egg.types';

export function getNextVariant(previous: Variant | null): Variant {
  let prev: Variant | null = previous;
  try {
    const stored = typeof window !== 'undefined' ? window.sessionStorage.getItem(STORAGE_KEYS.lastVariant) : null;
    if (stored === 'wink' || stored === 'shock') prev = prev ?? stored;
  } catch {}

  const choice: Variant =
    prev === 'wink' ? 'shock' : prev === 'shock' ? 'wink' : Math.random() < 0.5 ? 'wink' : 'shock';

  return choice;
}

export function getNextCopyIndex(previousIndex: number | null): number {
  const idx = Math.floor(Math.random() * COPY_VARIATIONS.length);
  if (previousIndex !== null && idx === previousIndex) return (idx + 1) % COPY_VARIATIONS.length;
  return idx;
}
